module.exports = __webpack_public_path__ + "img/defaultAva.4d612405.png";